import {useState,useContext, useEffect, useRef} from 'react'
import { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import SVG from "react-inlinesvg";
import IconFilter from '../img/icons/icon_filter.svg'
import IconSearch from '../img/icons/icon_search.svg'
import IconSearchDelete from '../img/icons/icon_search_delete.svg'
import Select from 'react-select';
import Switch from "react-switch";
import {device} from "../media"
import styled from 'styled-components'
import Button from '../components/Button'
import Dropdown from './Dropdown';

const SearchBar = ({value, setValue, filterAreaOptions, filterAreaValue, setFilterAreaValue,  onSearchButton, extendedSearch, searchTitlesOnly, setSearchTitlesOnly}) => {
    const {t} = useTranslation()
    const themeContext = useContext(ThemeContext);
    const [dropdownActive, setDropdownActive] = useState(false)
    const ref = useRef(null)
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref && ref.current && !ref.current.contains(event.target)) {
                    // @ts-ignore
                    setDropdownActive(false)

                
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const isFilterActive = () => {
        return filterAreaOptions.length > 2 || extendedSearch
    }



    return (
        <Wrapper>
            <SearchWrapper>
                <SearchIcons>
                    <IconLeft src={IconSearch}/>
                    {
                        value &&
                        <IconRight filterActive={isFilterActive()} onClick={() => setValue("")} src={IconSearchDelete}/>
                    }
                    
                </SearchIcons>
                <SearchForm onSubmit={onSearchButton}>
                    	<SearchInput placeholder={t('search_placeholder')} value={value} onChange={(e) => setValue(e.target.value)} autoFocus />
                </SearchForm>
                {
                    (isFilterActive()) && 
                    <OutsideClickHelper ref={ref}>
                            
                            <FilterButton  onClick={() => setDropdownActive(!dropdownActive)}>
                                <FilterIcon src={IconFilter}/>
                                <FilterText>
                                    {t('filter')}
                                </FilterText>

                            </FilterButton>
 
                        <Dropdown active={dropdownActive}>
                                <DropdownWrapper>

                                    {         
                                        filterAreaOptions.length > 2 &&   
                                        <>   
                                            <DropdownTitle>{t('filter_title')}</DropdownTitle>                  
                                            <Select
                                                styles={selectStyles}
                                                value={filterAreaValue}
                                                onChange={setFilterAreaValue}
                                                options={filterAreaOptions}
                                                />
                                        </>
                                    }
                                    {
                                        extendedSearch &&
                                        <ToggleLabel>
                                            <Switch
                                                checked={searchTitlesOnly}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                onColor={themeContext.color.primary}
                                                offColor={themeContext.color.grey_200}
                                                height={23}
                                                width={45}
                                                onChange={(nextChecked) => setSearchTitlesOnly(nextChecked)} />
                                            <ToggleText>{t('search_titles_only')}</ToggleText>
                                        </ToggleLabel>
                                    }
                                </DropdownWrapper>
                        </Dropdown>
                    </OutsideClickHelper>

                }


            </SearchWrapper>
            
            <Button primary inactive={value === ''} title={t('search')} onClick={onSearchButton}/>
        </Wrapper>
    )
}

export default SearchBar

const selectStyles = {
    indicatorSeparator: () => ({
        width: '0px',
    }),
    input: (provided, _) => ({
        ...provided,
        fontWeight: 400,
        fontSize: '14px',
        color: "#0F172A"
    }),
    control: (provided, _) => ({
        ...provided,
        border: "1px solid #E2E8F0",
        borderRadius: "8px",
        height: "38px",
        boxShadow: 'none',
        "&:hover": {
            border: "1px solid #CBD5E1"
        }
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#F1F5F9' : state.isFocused ? "#F8FAFC" : 'FFF',
        color: 'black',
        cursor: state.isFocused ? 'pointer' : 'auto',
        fontSize: "14px",
        padding: "12px",
        "&:active": {
            backgroundColor: state.isSelected ? "#E2E8F0" : '#F1F5F9'
        }
    }),
    menu: (provided, state) => ({
        ...provided,
        borderRadius: "8px",
    })
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    margin-bottom: 32px;

`

const SearchWrapper = styled.div`
    position: relative;
    border: 1px solid ${props => props.theme.color.grey_200};
    box-sizing: border-box;
    /* Shadow/XS */

    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    display: flex;
    height: 38px;
    width: 100%;
    &:focus-within {
        border: 1px solid ${props => props.theme.color.primary};
    }
`

const SearchIcons = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    pointer-events: none;
`


const IconRight = styled(SVG)<{filterActive: boolean}>`
    margin-right: ${props => props.filterActive ? "110px" : "20px"};
    cursor: pointer;
    pointer-events: all;
        @media ${device.mobile}{
            margin-right: ${props => props.filterActive ? "50px" : "20px"};
    }
`
const IconLeft = styled(SVG)`
    margin-left: 12px;
`

const FilterIcon = styled(SVG)`
    margin-right: 8px;
    @media ${device.mobile}{
        margin-right: 0px;
    }
`   

const FilterText = styled.span`
      @media ${device.mobile}{
        font-size: 0;
    }
`

const SearchForm = styled.form`
    flex: 1;
    display: flex; 
    align-items: center;
    
`

const SearchInput = styled.input`
    width: 100%;
    border: none;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 100%;
    margin-left: 34px;
    padding-right: 44px;
    color: ${props => props.theme.color.grey_900};
    &:focus {
        outline: none;
    }

    ::placeholder,
    ::-webkit-input-placeholder {
        color: ${props => props.theme.color.grey_400};
        
    }
    :-ms-input-placeholder {
        color: ${props => props.theme.color.grey_400};
        font-size: 12px;
    }

    @media ${device.mobile}{
        ::placeholder,
        ::-webkit-input-placeholder {
            font-size: 12px;
            
        }
        :-ms-input-placeholder {
            font-size: 12px;
        }
    }
`

const DropdownWrapper = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
`

const DropdownTitle = styled.span`
    margin-bottom: 6px;
    color: ${props => props.theme.color.grey_700};
    font-weight: 500;
    font-size: 14px;
`

const FilterButton = styled.span`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    font-weight: 500;
    font-size: 14px;
    color: ${props => props.theme.color.grey_900};
    background: ${props => props.theme.color.grey_100};
    -moz-border-radius-topright: 8px;
    -webkit-border-top-right-radius: 8px;
    -moz-border-radius-bottomright: 8px;
    -webkit-border-bottom-right-radius: 8px;
    height: 100%;
    @media ${device.mobile}{
        padding: 0 14px;
    }
    &:hover {
        background: ${props => props.theme.color.grey_200};
    }
`

const OutsideClickHelper = styled.span``

const ToggleLabel = styled.label`
    display: flex;
    align-items: center;
`

const ToggleText = styled.div`
    margin-left: 8px;
`